<button
  type="button"
  mat-icon-button
  [attr.aria-label]="isVisible ? 'Verberg wachtwoord' : 'Toon wachtwoord'"
  (click)="toggleVisibility()"
>
  <mat-icon>{{ isVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
</button>
